import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

const styles = theme => ({
  root: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 16,
    marginTop: theme.spacing.unit * 3,
  }),
});


function Popup({ classes, title, items, id}) {
  
  var key = 0;

  return (
    <div id={id} style={{
    	 backgroundColor: '#fff',
       maxWidth: '400px' 
    	}}>
      <Paper className={classes.root} elevation={4}>
        <Typography type="headline" component="h3">
          <div style={{fontSize:'105%'}}>{title ? title : ''}</div>
        </Typography>
        <div>
          {items ? (items.map((item)=>{
          	return (<div key={key++} style={{color:'#515151'}}>{ item }</div>);
          })) : ''}
        </div>
      </Paper>
    </div>
  );
}

Popup.propTypes = {
  id: PropTypes.string,
  title: PropTypes.string,
  items: PropTypes.array,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Popup);